/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/dot-notation */
import React, { useEffect, useRef, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { WalkthroughTourContext } from '../../contexts/WalkthroughTour';

import './style.scss';

const steps = [
    {},
    {
        type: 'redirect',
        route: '/'
    },
    {
        type: 'message',
        message: 'Welcome to Zelp'
    },
    {
        type: 'focus',
        query: '#walkthrough-step-1',
        message: 'Ranking list View',
    },
    {
        type: 'focus',
        query: '.router-div',
        message: null,
    },
    {
        type: 'focus',
        query: '.ranking-block_top',
        message: 'See your best performing Animals for breeding stock',
    },
    {
        type: 'focus',
        query: '.ranking-list-headline',
        message: 'Sort them based on different fields',
    },
    {
        type: 'focus',
        query: '.ranking-filters-bar-container',
        message: 'Or filter them based on Time-period, group, Age, Breed, Sex, etc. ',
    },
    {
        type: 'focus',
        query: '#walkthrough-step-2',
        message: 'Farm Dashboard reduces the labour of Farm monitoring',
    },
    {
        type: 'redirect',
        route: '/methane'
    },
    {
        type: 'message',
        message: 'Get useful information about animals during the different time periods at a glance.'
    },
    {
        type: 'focus',
        query: '.router-div',
        message: null,
    },
    {
        type: 'focus',
        query: '#walkthrough-step-3',
        message: 'Keep track of farm activity',
    },
    {
        type: 'redirect',
        route: '/add'
    },
    {
        type: 'focus',
        query: '.add-page_list',
        message: 'Add different types of events and animals here',
    },
    {
        type: 'focus',
        query: '#walkthrough-step-4',
        message: 'User and AI added events and farm activity are in logs',
    },
    {
        type: 'redirect',
        route: '/log'
    },
];

const margins = {
    top: 10, left: 10, bottom: 10, right: 10
};

/**
 * WalkThroughTour
 * @param {<React component/>} WalkthroughTour
 */

const WalkthroughTour = props => {

    const history = useHistory();
    const { step, setStep } = useContext(WalkthroughTourContext);

    const tourFocusRef = useRef(null);
    const tourMessageRef = useRef(null);

    // const [step, setStep] = useState(0);

    useEffect(() => {
        if (step !== 0 && steps[step]?.type && (steps[step].type === 'focus') && steps[step]?.query) {
            const dimensions = document.querySelector(steps[step].query)?.getBoundingClientRect();
            tourFocusRef.current.style['width'] = (dimensions.width + margins.left + margins.right) + 'px';
            tourFocusRef.current.style['height'] = (dimensions.height + margins.top + margins.bottom) + 'px';
            tourFocusRef.current.style['top'] = (dimensions.top - margins.top) + 'px';
            tourFocusRef.current.style['bottom'] = (dimensions.top + dimensions.height + margins.bottom) + 'px';
            tourFocusRef.current.style['left'] = (dimensions.left - margins.left) + 'px';
            tourFocusRef.current.style['right'] = (dimensions.left + dimensions.width + margins.right) + 'px';

            if (tourMessageRef && tourMessageRef.current &&
                ((dimensions.width >= window.innerWidth / 2) || window.innerWidth <= 768)) {
                // mobile or desktop when focused area is +50% of the screen
                tourMessageRef.current.style['width'] = '90%';
                tourMessageRef.current.style['margin'] = 'auto';
                tourMessageRef.current.style['left'] = '5%';
                if ((dimensions.top + (dimensions.height / 2)) < (window.innerHeight / 2)) {
                    // focus area is in upper half of the screen, so put message in bottom side of focus area
                    tourMessageRef.current.style['top'] = `${(dimensions.top + dimensions.height + 30)}px`;
                    tourMessageRef.current.style['bottom'] = 'auto';
                }
                else {
                    // focus area is in lower half of the screen, so put message in top side of focus area
                    tourMessageRef.current.style['bottom'] = `calc(100vh - ${(dimensions.top - 30)}px)`;
                    tourMessageRef.current.style['top'] = 'auto';
                }
            }
            else if (tourMessageRef && tourMessageRef.current) {
                // desktop
                tourMessageRef.current.style['width'] = '30rem';
                tourMessageRef.current.style['max-width'] = '40%';
                tourMessageRef.current.style['box-sizing'] = 'border-box';
                tourMessageRef.current.style['padding'] = '1.5rem';
                if ((dimensions.top + (dimensions.height / 2)) < (window.innerHeight / 2)) {
                    // focus area is in upper half of the screen, so put message in bottom side of focus area
                    if (dimensions.height > ((window.innerHeight / 3) * 2)) {
                        tourMessageRef.current.style['top'] = `${(window.innerHeight / 2 - 30)}px`;
                    }
                    else {
                        tourMessageRef.current.style['top'] = `${(dimensions.top)}px`;
                    }
                    tourMessageRef.current.style['bottom'] = 'auto';
                    if ((dimensions.left + (dimensions.width / 2)) < (window.innerWidth / 2)) {
                        // in upper left
                        tourMessageRef.current.style['right'] = 'auto';
                        tourMessageRef.current.style['left'] = (dimensions.left + dimensions.width + 30) + 'px';
                    }
                    else {
                        // in upper right
                        tourMessageRef.current.style['right'] = `calc(100% - ${(dimensions.left - 30)}px)`;
                        tourMessageRef.current.style['left'] = '5%';
                    }
                }
                else {
                    // focus area is in lower half of the screen, so put message in top side of focus area
                    if (dimensions.height > ((window.innerHeight / 3) * 2)) {
                        tourMessageRef.current.style['bottom'] = `${(window.innerHeight / 2 + 30)}px`;
                    }
                    else {
                        tourMessageRef.current.style['bottom'] = `calc(100vh - ${(dimensions.top)}px)`;
                    }
                    if ((dimensions.left + (dimensions.width / 2)) < (window.innerWidth / 2)) {
                        // in bottom left
                        tourMessageRef.current.style['right'] = 'auto';
                        tourMessageRef.current.style['left'] = (dimensions.left + dimensions.width + 30) + 'px';
                    }
                    else {
                        // in bottom right
                        tourMessageRef.current.style['right'] = `calc(100% - ${(dimensions.left - 30)}px)`;
                        tourMessageRef.current.style['left'] = '5%';
                    }
                }
            }
        }
        else if (step !== 0 && steps[step]?.type && (steps[step].type === 'redirect') && steps[step]?.route) {

            history.push(steps[step].route);
            tourFocusRef && (tourFocusRef.current.style['width'] = '0px');
            tourFocusRef && (tourFocusRef.current.style['height'] = '0px');
            setTimeout(() => {
                setStep(step + 1);
            }, 1500); // wait to loadnew route
        }
        else if (step !== 0 && steps[step]?.type && (steps[step].type === 'message')) {
            tourFocusRef.current.style['width'] = '1px';
            tourFocusRef.current.style['height'] = '1px';
            tourFocusRef.current.style['top'] = '0';
            tourFocusRef.current.style['left'] = '0';
            tourMessageRef.current.style['text-align'] = 'center';
            tourMessageRef.current.style['width'] = '90%';
            tourMessageRef.current.style['left'] = '5%';
            tourMessageRef.current.style['bottom'] = '70%';
        }
        else {
            tourFocusRef.current.style['width'] = '100%'
            tourFocusRef.current.style['height'] = '100vh;';
            tourFocusRef.current.style['top'] = '0';
            tourFocusRef.current.style['left'] = '0';
            tourFocusRef.current.style['bottom'] = '0';
            tourFocusRef.current.style['right'] = '0';
            setStep(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step]);

    return (
        <div>
            {props.children}

            <div
                className={step ? 'walkthrough-tour-container' : 'walkthrough-tour-container__hide'}
                role="button"
                tabIndex={step ? 0 : -1}
                aria-label="Next step"
                onClick={() => { setStep(step + 1) }}
                onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setStep(step + 1);
                    } else if (e.key === 'Escape') {
                        e.preventDefault();
                        setStep(0);
                    }
                }}>
                <div
                    className={step === 0 ? 'walkthrough-tour-initial' : 'walkthrough-tour'}
                    ref={tourFocusRef} />
                {steps[step] && steps[step].message ?
                    <div className="tour-message" ref={tourMessageRef}>
                        <span>{steps[step].message}</span>
                    </div> : ''}
                <div
                    className="walkthrough-tour_close"
                    role="button"
                    tabIndex={step ? 0 : -1}
                    aria-label="Close tour"
                    onClick={(e) => { e.stopPropagation(); setStep(0); }}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            e.stopPropagation();
                            setStep(0);
                        }
                    }}
                    title="Close">
                    ×
                </div>
            </div>
        </div>
    )
}

export default WalkthroughTour;
